module.exports = __webpack_public_path__ + "assets/media/play-market-about.9529ea6c.svg";